import {NsjAuthInstance} from '@core/authentication/nsj-autenticacao';
import {PublicPagesRouter} from '@core/public-pages/public-pages.router';
import {PainelAdministrativoRouter} from '@core/painel-administrativo/painel-administrativo.router';
import {configInstance} from '@core/configuracao/nsj-config';
import {Catch} from "@core/decorators/catch";
import {httpClient} from '@core/services/http-client';

import {NsjRoutingInstance} from '@core/routing/nsj-rotas';
import {ErrorPageMessagePayload, ServerError} from "@core/services/server-error";

import {Estabelecimento, Grupoempresarial, Organizacao, Trabalhador, Usuario} from '@core/usuario/models/usuario-model';
import {NsjUsuarioInstance} from '@core/usuario/nsj-usuario';
import {decodificarComponenteUrl, normalizarUrlSemProtocolo, removerFragmentoDaUrlNavegador} from '@utils/utils';

class InicializacaoService {

    constructor(private config: any, private bootstrap: Function, private usaGrupoEmpresarial: boolean = true, private usaEstabelecimento: boolean = false) {

    }

    async run() {
        configInstance.iniciarConfig(this.config);
        PublicPagesRouter.initRouter();
        if (PublicPagesRouter.isPublicRoute()) {
            return;
        }

        // Painel interno da Nasajon: exige login, mas não é por tenant.
        if (PainelAdministrativoRouter.isRota()) {
            await PainelAdministrativoRouter.iniciar();
            return;
        }

        NsjAuthInstance.iniciarAuth()
            .then(() => removerFragmentoDaUrlNavegador())
            .then(() => NsjRoutingInstance.carregarRotas())
            .then(() => NsjUsuarioInstance.carregarUsuario())
            .then(() => this.bootstrapApp())
    }

    @Catch('object', (error: Error & { errorPagePayload?: ErrorPageMessagePayload } , ctx) => {
        console.error({error, ctx});
        ServerError.showErrorPage(error.errorPagePayload || error.message);
    })

    async bootstrapApp() {

        const usuario: Usuario = NsjUsuarioInstance.Usuario;
        let tenantCodigo: string = '';
        let grupoEmpresarialCodigo: string = '';

        let tenant: Organizacao
        let grupoempresarial: Grupoempresarial; // grupoempresarialobj
        let estabelecimento: any;
        let globals: any = {};

        let trabalhador: boolean | Trabalhador = false;

        if (usuario.trabalhador && usuario.trabalhador.length > 0) {
            trabalhador = usuario.trabalhador[0];
        }

        if (!usuario) {
            throw this.criarErroPagina('usuario_nao_carregado');
        }

        if(usuario.tenant_url_bloqueada){
          throw this.criarErroPagina('tenant_bloqueado');
        }

        //Busco se usuário possui algum tenant
        tenant = usuario.organizacoes.find((tenant) => {
            return tenant;
        });

        //Caso o usuário não possua tenant, retorno erro.
        if (!tenant) {
            throw this.criarErroPagina('usuario_sem_tenant');
        }

        //Caso utilize Grupo Empresarial na URL base, busco o primeiro grupo do tenant selecionado 
        if (this.usaGrupoEmpresarial) {

          grupoempresarial = tenant.gruposempresariais.find((grupoempresarial) => { // grupoempresarialobj
                return grupoempresarial;
            });

            //Caso o usuário não possua Grupo Empresarial, retorno erro.
            if (!grupoempresarial) { // grupoempresarialobj
                throw this.criarErroPagina('usuario_sem_grupo_empresarial');
            }

            tenantCodigo = tenant.codigo;
            grupoEmpresarialCodigo = grupoempresarial.codigo; // grupoempresarialobj
        }

        //   Busco dados de tenant e grupo empresarial presentes na url
        const indexUrl = window.location.href.indexOf('://') + 3;
        const indexUrlParams = window.location.href.indexOf('?');
        let urlSemProtocolo = normalizarUrlSemProtocolo(window.location.href);
        let baseTag = document.getElementsByTagName('base')[0];

        const dadosUrl = urlSemProtocolo.split('/');
      if (this.usaEstabelecimento) {
        const urlPaginaInicial = window.location.href.substring(0, indexUrl) + dadosUrl[0] + '/';

        //  até tratar urls no localhost
        if (!dadosUrl[0].includes('localhost')) {
          usuario.organizacoes.forEach((element: any) => {
            let domain = dadosUrl[0].split('.');
            domain[0] = element.codigo;
            //  domain = domain.join('.');
            element.url = window.location.href.substring(0, indexUrl) + domain.join('.');
            return element;
          });
        }

        // resolve tenant, grupo e estabelecimento a partir do path e completa ausências com query params.
        let domain = dadosUrl[0].split('.');
        let tenantUrl = !domain[0].includes('localhost') ? domain[0] : (dadosUrl.length > 1 && dadosUrl[1] !== '') ? dadosUrl[1] : null;
        let grupoempresarial = (dadosUrl.length > 1 && dadosUrl[1] !== '') ? dadosUrl[1] : null;
        let estabelecimento = (dadosUrl.length > 2 && dadosUrl[2] !== '') ? dadosUrl[2] : null;
        // caso tenant não exista no corpo da url e existam parametros de url, busco nos parametros
        if ((tenantUrl === null || grupoempresarial === null || estabelecimento === null) && indexUrlParams > -1) {
          const params = window.location.href.substring(indexUrlParams + 1).split('&');
          const arrParams = params.map((paramText) => {
            const arrChaveValor = paramText.split('=');

            return {
              nome: arrChaveValor[0],
              valor: arrChaveValor.length > 1 ? arrChaveValor[1] : ''
            };
          });
          const paramTenant = arrParams.find((param) => {
            return (param.nome === 'tenant');
          });

          if (paramTenant) {
            tenantUrl = paramTenant.valor;
          }

          const paramGrupoempresarial = arrParams.find((param) => {
            return (param.nome === 'grupoempresarial');
          });

          if (paramGrupoempresarial) {
            grupoempresarial = paramGrupoempresarial.valor;
          }

          const paramEstabelecimento = arrParams.find((param) => {
            return (param.nome === 'estabelecimento');
          });

          if (paramEstabelecimento) {
            estabelecimento = paramEstabelecimento.valor;
          }

        }

        grupoempresarial = decodificarComponenteUrl(grupoempresarial);
        estabelecimento = decodificarComponenteUrl(estabelecimento);

        // caso não tenha o tenant/grupoempresarial/estabelecimento nem no corpo quanto nos parâmetros da URL, pego as informações do primeiro tenant
        tenantUrl = tenantUrl === null ? usuario.organizacoes[0].codigo : tenantUrl;
        // caso encontre tenant da url no perfil do usuário, seto esses valores para colocar na base da url
        const tenantCompleto = usuario.organizacoes.find((tenant: any) => {
          return tenant.codigo === tenantUrl;
        });

        if (!tenantCompleto) {
          throw this.criarErroPagina('tenant_invalido');
        }

        if (tenantCompleto) {
          const grupoEmpresarialInformado = grupoempresarial;
          // descarta grupos e empresas sem estabelecimentos para identificar se o usuário ainda tem acessos válidos.
          tenantCompleto.gruposempresariais = this.filtrarGruposComEstabelecimentos(tenantCompleto.gruposempresariais);
          const possuiGruposComEstabelecimentos =
            typeof tenantCompleto.gruposempresariais !== 'undefined' &&
            tenantCompleto.gruposempresariais.length > 0;

          if (!possuiGruposComEstabelecimentos) {
            throw this.criarErroPagina('usuario_sem_estabelecimentos_acessiveis');
          }

          // quando a url não informa estabelecimento, o sistema tenta resolver um contexto inicial automaticamente.
          if (estabelecimento === null) {
            const contextoInicial = this.resolverContextoInicial(
              tenantCompleto,
              grupoempresarial,
              usuario.ultimo_estabelecimento_logado
            );

            if (contextoInicial) {
              grupoempresarial = contextoInicial.grupoempresarial.codigo;
              estabelecimento = contextoInicial.estabelecimento.id;
            } else if (grupoEmpresarialInformado !== null) {
              throw this.criarErroPagina('grupo_invalido');
            }
          // quando a url já informa estabelecimento, o fluxo só valida o contexto sem aplicar fallback automático.
          } else if (grupoempresarial !== null) {
            const contextoInformado = this.validarContextoInformadoNaUrl(
              tenantCompleto,
              grupoempresarial,
              estabelecimento
            );

            if (contextoInformado === 'grupo_invalido') {
              throw this.criarErroPagina('grupo_invalido');
            }

            if (contextoInformado === 'estabelecimento_invalido') {
              throw this.criarErroPagina('estabelecimento_invalido');
            }
          }
        }

        // este é o guarda final para os casos em que nenhum estabelecimento pôde ser resolvido.
        if (typeof estabelecimento === 'undefined' || estabelecimento === null) {
          throw this.criarErroResolucaoEstabelecimento(grupoempresarial);
        }
        // seto a base da url do sistema
        baseTag.href = baseTag.href + encodeURIComponent(grupoempresarial) + '/' + encodeURIComponent(estabelecimento) + '/';

        usuario.logout_url = NsjAuthInstance.nsjAuth.createLogoutUrl({
          redirectUri: baseTag.href
        });

        const url = NsjRoutingInstance.Routing.generate('app_globals_globals', {
          tenant: tenantCompleto.codigo,
          grupoempresarial: grupoempresarial,
          estabelecimento: estabelecimento
        }, true)

        globals = await (await httpClient.get<any>(url, true)).parsedBody;
        // código temporário para tornar compatível com a nomenclatura usada no nsj-rotas
        globals['grupoEmpresarialCodigo'] = globals.grupoempresarial;
        globals['tenantCodigo'] = globals.tenant;

      } else {

        //Verifico se existe tenant e grupo empresarial na url, considerando que dadosUrl[0] é o host.
        let tenantUrl = (dadosUrl.length > 1) ? dadosUrl[1] : null;
        let grupoEmpresarialUrl = (dadosUrl.length > 2) ? dadosUrl[2] : null;

        //Caso tenant/grupo empresarial não existam no corpo da url e existam parametros de url, busco nos parametros
        if ((tenantUrl == null && grupoEmpresarialUrl == null) && indexUrlParams > -1) {
            const params = window.location.href.substring(indexUrlParams + 1).split('&');
            const arrParams = params.map((paramText) => {
                const arrChaveValor = paramText.split('=');

                return {
                    nome: arrChaveValor[0],
                    valor: arrChaveValor.length > 1 ? arrChaveValor[1] : ''
                };
            });

            const paramTenant = arrParams.find((param) => {
                return (param.nome == 'tenant');
            });

            if (paramTenant) {
                tenantUrl = paramTenant.valor;

                const paramGrupoEmpresarial = arrParams.find((param) => {
                    return (param.nome == 'grupoempresarial');
                });

                if (paramGrupoEmpresarial) {
                    grupoEmpresarialUrl = paramGrupoEmpresarial.valor;
                }
            }
        }

        grupoEmpresarialUrl = decodificarComponenteUrl(grupoEmpresarialUrl);

        //Caso encontro tenant e grupo empresarial da url no perfil do usuário, seto esses valores para colocar na base da url
        const tenantCompleto = usuario.organizacoes.find((tenant) => {
            return tenant.codigo == tenantUrl
        });

        if (tenantCompleto) {
            const grupoEmpresarialCompleto = tenantCompleto.gruposempresariais.find((grupo) => {
                return grupo.codigo == grupoEmpresarialUrl;
            });

            if (grupoEmpresarialCompleto) {
                tenantCodigo = tenantCompleto.codigo;
                grupoEmpresarialCodigo = grupoEmpresarialCompleto.codigo;
            }
        }

        //Busco a tag Base
        let baseTag = document.getElementsByTagName('base')[0];

        //Seto a base da url do sistema
        baseTag.href = baseTag.href + (this.usaGrupoEmpresarial ? tenantCodigo + '/' + encodeURIComponent(grupoEmpresarialCodigo) + '/' : tenantCodigo + '/');

        //Adiciono Url de redirecionamento no logout do sistema. Quando deslogar, vai pra página inicial
        usuario.logout_url = NsjAuthInstance.nsjAuth.createLogoutUrl({
            redirectUri: baseTag.href
        });

        globals = {tenantCodigo, grupoEmpresarialCodigo};
      }

      configInstance.setConfig('globals', globals);

      //Pegar o parâmetro redirect_uri da url para iniciar a aplicação direto na página definida
      let redirect_uri = decodeURI(getRedirectParam());
      this.bootstrap(redirect_uri);
    }

    getGrupoempresarialUsuario(trabalhador: Trabalhador, gruposempresariais: Grupoempresarial[]): Grupoempresarial {
      return gruposempresariais.find((grupoempresarial => grupoempresarial.id === trabalhador.grupoempresarial));
    }

    getEstabelecimentoUsuario(trabalhador: Trabalhador, grupoempresarial: Grupoempresarial) {
      // let estabelecimento: Estabelecimento = null;
      // grupoempresarial.empresas.map(empresa => {
      //   estabelecimento = empresa.estabelecimentos.find(estabelecimento => estabelecimento.id === trabalhador.estabelecimento);
      // });

      let estabelecimento = grupoempresarial.empresas.find(empresa => {
        return empresa.estabelecimentos.find(estabelecimento => estabelecimento.id === trabalhador.estabelecimento);
      });

      return estabelecimento;
    }

    /**
     * Remove grupos e empresas que não têm mais estabelecimentos acessíveis para o usuário.
     */
    private filtrarGruposComEstabelecimentos(gruposempresariais: Grupoempresarial[]): Grupoempresarial[] {
      return gruposempresariais
        .map((grupoempresarial) => ({
          ...grupoempresarial,
          empresas: grupoempresarial.empresas.filter((empresa) => {
            return empresa.estabelecimentos && empresa.estabelecimentos.length > 0;
          })
        }))
        .filter((grupoempresarial) => {
          return grupoempresarial.empresas.length > 0;
        });
    }

    /**
     * Resolve grupo e estabelecimento apenas quando a url não informou estabelecimento.
     */
    private resolverContextoInicial(
      tenantCompleto: Organizacao,
      grupoempresarialCodigo: string | null,
      ultimoEstabelecimentoLogado: string | null
    ): { grupoempresarial: Grupoempresarial, estabelecimento: Estabelecimento } | null {
      const grupoUltimoEstabelecimento = ultimoEstabelecimentoLogado
        ? this.buscarGrupoPorEstabelecimento(tenantCompleto.gruposempresariais, ultimoEstabelecimentoLogado)
        : null;

      let grupoSelecionado: Grupoempresarial | null = null;

      if (grupoempresarialCodigo) {
        grupoSelecionado = tenantCompleto.gruposempresariais.find((grupo) => grupo.codigo === grupoempresarialCodigo) || null;

        if (!grupoSelecionado) {
          return null;
        }
      } else {
        grupoSelecionado = grupoUltimoEstabelecimento;
      }

      if (!grupoSelecionado) {
        grupoSelecionado = tenantCompleto.gruposempresariais[0] || null;
      }

      if (!grupoSelecionado) {
        return null;
      }

      const estabelecimentoSelecionado = ultimoEstabelecimentoLogado
        ? this.buscarEstabelecimentoNoGrupo(grupoSelecionado, ultimoEstabelecimentoLogado)
        : null;

      const primeiroEstabelecimento = this.getPrimeiroEstabelecimentoGrupo(grupoSelecionado);

      if (!estabelecimentoSelecionado && !primeiroEstabelecimento) {
        return null;
      }

      return {
        grupoempresarial: grupoSelecionado,
        estabelecimento: estabelecimentoSelecionado || primeiroEstabelecimento!
      };
    }

    /**
     * Valida grupo e estabelecimento explícitos na url sem trocar silenciosamente para outro contexto.
     */
    private validarContextoInformadoNaUrl(
      tenantCompleto: Organizacao,
      grupoempresarialCodigo: string,
      estabelecimentoId: string
    ): 'grupo_invalido' | 'estabelecimento_invalido' | 'ok' {
      const grupoSelecionado = tenantCompleto.gruposempresariais.find((grupo) => grupo.codigo === grupoempresarialCodigo) || null;

      if (!grupoSelecionado) {
        return 'grupo_invalido';
      }

      const estabelecimentoSelecionado = this.buscarEstabelecimentoNoGrupo(grupoSelecionado, estabelecimentoId);

      if (!estabelecimentoSelecionado) {
        return 'estabelecimento_invalido';
      }

      return 'ok';
    }

    /**
     * Escolhe a mensagem final conforme o ponto em que a resolução do estabelecimento falhou.
     */
    private criarErroResolucaoEstabelecimento(grupoempresarialCodigo: string | null): Error {
      if (grupoempresarialCodigo) {
        return this.criarErroPagina('grupo_sem_estabelecimentos');
      }

      return this.criarErroPagina('falha_resolucao_estabelecimento');
    }

    private criarErroPagina(
      tipo:
        | 'usuario_nao_carregado'
        | 'tenant_bloqueado'
        | 'usuario_sem_tenant'
        | 'usuario_sem_grupo_empresarial'
        | 'usuario_sem_estabelecimentos_acessiveis'
        | 'tenant_invalido'
        | 'grupo_invalido'
        | 'estabelecimento_invalido'
        | 'grupo_sem_estabelecimentos'
        | 'falha_resolucao_estabelecimento'
    ): Error {
      const mensagem = this.getMensagemErro(tipo);
      const erro: Error & { errorPagePayload?: ErrorPageMessagePayload } = new Error(mensagem.mensagemPrincipal);

      erro.errorPagePayload = mensagem;

      return erro;
    }

    private getMensagemErro(
      tipo:
        | 'usuario_nao_carregado'
        | 'tenant_bloqueado'
        | 'usuario_sem_tenant'
        | 'usuario_sem_grupo_empresarial'
        | 'usuario_sem_estabelecimentos_acessiveis'
        | 'tenant_invalido'
        | 'grupo_invalido'
        | 'estabelecimento_invalido'
        | 'grupo_sem_estabelecimentos'
        | 'falha_resolucao_estabelecimento'
    ): ErrorPageMessagePayload {
      switch (tipo) {
        case 'usuario_nao_carregado':
          return {
            mensagemPrincipal: 'Não foi possível carregar os dados da sua conta.'
          };
        case 'tenant_bloqueado':
          return {
            mensagemPrincipal: 'O acesso a este ambiente está suspenso no momento.',
            mensagemComplementar: 'O acesso a este tenant está suspenso. Entre em contato com a Nasajon.'
          };
        case 'usuario_sem_tenant':
          return {
            mensagemPrincipal: 'Sua conta não possui acesso ao sistema.',
            mensagemComplementar: 'A conta não possui acesso a nenhum tenant.'
          };
        case 'usuario_sem_grupo_empresarial':
          return {
            mensagemPrincipal: 'Sua conta não possui acesso ao sistema.',
            mensagemComplementar: 'A conta não possui acesso a nenhum grupo empresarial.'
          };
        case 'usuario_sem_estabelecimentos_acessiveis':
          return {
            mensagemPrincipal: 'Sua conta não possui acesso ao sistema.',
            mensagemComplementar: 'A conta não possui acesso a nenhum estabelecimento.'
          };
        case 'tenant_invalido':
          return {
            mensagemPrincipal: 'Não foi possível encontrar o ambiente informado.',
            mensagemComplementar: 'Verifique se a URL digitada está correta.'
          };
        case 'grupo_invalido':
          return {
            mensagemPrincipal: 'O grupo empresarial informado na URL não está disponível para sua conta.',
            mensagemComplementar: 'O grupo empresarial informado na URL é inválido ou o usuário não possui acesso a ele.'
          };
        case 'estabelecimento_invalido':
          return {
            mensagemPrincipal: 'O estabelecimento informado na URL não está disponível para sua conta.',
            mensagemComplementar: 'O estabelecimento informado na URL é inválido ou o usuário não possui acesso a ele.'
          };
        case 'grupo_sem_estabelecimentos':
          return {
            mensagemPrincipal: 'Este grupo empresarial não possui estabelecimentos disponíveis para acesso.'
          };
        case 'falha_resolucao_estabelecimento':
          return {
            mensagemPrincipal: 'Não foi possível definir o estabelecimento inicial para abrir o sistema.'
          };
      }
    }

    private buscarGrupoPorEstabelecimento(gruposempresariais: Grupoempresarial[], estabelecimentoId: string): Grupoempresarial | null {
      return gruposempresariais.find((grupoempresarial) => {
        return grupoempresarial.empresas.some((empresa) => {
          return empresa.estabelecimentos.some((estabelecimento) => estabelecimento.id === estabelecimentoId);
        });
      }) || null;
    }

    private buscarEstabelecimentoNoGrupo(grupoempresarial: Grupoempresarial, estabelecimentoId: string): Estabelecimento | null {
      for (const empresa of grupoempresarial.empresas) {
        const estabelecimento = empresa.estabelecimentos.find((item) => item.id === estabelecimentoId);

        if (estabelecimento) {
          return estabelecimento;
        }
      }

      return null;
    }

    private getPrimeiroEstabelecimentoGrupo(grupoempresarial: Grupoempresarial): Estabelecimento | null {
      for (const empresa of grupoempresarial.empresas) {
        if (empresa.estabelecimentos.length > 0) {
          return empresa.estabelecimentos[0];
        }
      }

      return null;
    }
}

function getRedirectParam() {
  const match = RegExp('[?&]redirect_uri=(.*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export const NsjInicializacao = InicializacaoService;
